import React from "react";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Diversity1OutlinedIcon from "@mui/icons-material/Diversity1Outlined";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import { ArrowLeftSquare, ArrowRightSquare } from "lucide-react";
import { toast } from "./ui/use-toast";

const Profiles = (props) => {
  let onlyFriends = props.onlyFriends;
  const [userfriends, setuserfriends] = useState([]);
  const fetchUserData = async () => {
    const oldDate = new Date();
    var curdate = oldDate.toDateString();
    let userEmail = localStorage.getItem("userEmail") || "example@gmail.com";

    let response = await fetch(
      "https://animedoro-backend.vercel.app/api/getstats",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: userEmail,
          curDate: curdate,
        }),
      }
    );
    const json = await response.json();
    if (response.status === 200) {
      let newarr = json.userFriends;
      newarr.push(userEmail);
      setuserfriends(json.userFriends);
    }
  };
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredboarddata, setfilteredboarddata] = useState([]);
  function onSearch(query) {
    setSearchQuery(query);
    let tempfbd = [];
    for (var i = 0; i < props.boarddata.length; i++) {
      let lowerword = props.boarddata[i].username.toLowerCase();
      if (lowerword.includes(query.toLowerCase())) {
        if (onlyFriends === 1) {
          if (userfriends.includes(props.boarddata[i].useremail) === true) {
            tempfbd.push(props.boarddata[i]);
          }
        } else {
          tempfbd.push(props.boarddata[i]);
        }
      }
    }
    setfilteredboarddata(tempfbd);
  }
  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <div style={{ paddingTop: "15px" }}>
      <input
        placeholder="  Search users by name"
        type="text"
        className="board-search"
        style={{ borderRadius: "25px", padding: "10px", marginTop: "20px" }}
        onChange={(e) => onSearch(e.target.value)}
      />

      {Item(
        searchQuery == "" ? props.boarddata : filteredboarddata,
        props.mode,
        userfriends,
        onlyFriends
      )}
    </div>
  );
};

export default Profiles;

function Item(data, mode, userfriends, onlyFriends) {
  if (onlyFriends === 1) {
    let newdata = [];
    for (var i = 0; i < data.length; i++) {
      if (userfriends.includes(data[i].useremail)) {
        newdata.push(data[i]);
      }
    }
    data = newdata;
  }
  const [sentRequests, setSentRequests] = useState([]);
  const ownEmail = localStorage.getItem("userEmail");

  async function sendreq(friendmail, friendname) {
    setSentRequests((prev) => [...prev, friendmail]);
    try {
      let response = await fetch(
        "https://animedoro-backend.vercel.app/api/friendrequest",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            useremail: ownEmail,
            friendmail: friendmail,
          }),
        }
      );
      const json = await response.json();
      if (json.msg) {
        toast({ title: "Friend request", description: json.msg });
      } else {
        toast({
          title: "Friend request sent!",
          description: `${
            friendname.charAt(0).toUpperCase() + friendname.slice(1)
          } can accept it from their notifications.`,
        });
      }
    } catch (e) {
      setSentRequests((prev) => prev.filter((m) => m !== friendmail));
      toast({
        title: "Something went wrong",
        description: "Couldn't send the friend request. Please try again.",
        variant: "destructive",
      });
    }
  }

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);
  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <>
      <div id="profile" className="flex flex-col justify-center px-1">
        {paginatedData.map((value, index) => {
          const rank = index + 1 + (currentPage - 1) * itemsPerPage;
          const isSelf = ownEmail && value.useremail === ownEmail;
          return (
            <Link
              key={value.useremail}
              className={`lb-row ${rank <= 3 ? `lb-top lb-top-${rank}` : ""}`}
              to="/stats"
              state={{ email: value.useremail }}
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }}
            >
              <div className={`lb-rank ${rank <= 3 ? `rank-${rank}` : ""}`}>
                {rank}
              </div>
              <div className="lb-avatar">
                {value.username[0].toUpperCase()}
              </div>
              <div className="lb-name">
                {value.username.charAt(0).toUpperCase() +
                  value.username.slice(1).toLowerCase()}
              </div>
              <div className="lb-minutes">
                <span className="lb-min-num">
                  {mode === 1 ? value.totalminutes : value.todayminutes}
                </span>
                <span className="lb-min-label">min</span>
              </div>
              {ownEmail ? (
                <div className="lb-action">
                  {isSelf ? (
                    <span className="board-pill muted">You</span>
                  ) : userfriends.includes(value.useremail) ? (
                    <span className="board-pill friends" title="You're friends">
                      <Diversity1OutlinedIcon style={{ fontSize: 15 }} />
                      <span className="board-pill-text">Friends</span>
                    </span>
                  ) : sentRequests.includes(value.useremail) ? (
                    <span className="board-pill muted">Sent ✓</span>
                  ) : (
                    <button
                      type="button"
                      className="board-pill add"
                      title={`Send a friend request to ${value.username}`}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        sendreq(value.useremail, value.username);
                      }}
                    >
                      <PersonAddAlt1OutlinedIcon style={{ fontSize: 15 }} />
                      <span className="board-pill-text">Add</span>
                    </button>
                  )}
                </div>
              ) : (
                <div className="lb-action"></div>
              )}
            </Link>
          );
        })}
      </div>
      <div className="pagination-controls flex w-full justify-center items-center gap-4">
        <button onClick={handlePreviousPage} disabled={currentPage === 1}>
          <ArrowLeftSquare size={30} />
        </button>
        <span style={{ margin: "0 10px" }}>
          Page {currentPage} of {totalPages}
        </span>
        <button onClick={handleNextPage} disabled={currentPage === totalPages}>
          <ArrowRightSquare size={30} />
        </button>
      </div>
    </>
  );
}
